import { Routes } from '@angular/router'
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular'
import { adminGuard } from './core/auth/admin.guard'
import { nonConformityGuard } from './core/auth/non-conformity.guard'
import { writeGuard } from './core/auth/write.guard'
import { inventoryGuard } from './core/auth/inventory.guard'
import { requisitionDraftGuard } from './core/auth/requisition-draft.guard'
import { LoginFailed } from './core/auth/login-failed/login-failed'
import { Logout } from './core/auth/logout/logout'
import { BaseLayout } from './v2/shared/components/layout/base-layout/base-layout'

// Pages en LAZY LOADING (loadComponent) : chaque écran devient son propre chunk — le bundle
// initial ne porte plus que le shell. Seuls le layout et les écrans d'auth restent eager.
export const routes: Routes = [
  { path: 'auth', component: MsalRedirectComponent },
  { path: 'logout', component: Logout },
  { path: 'login-failed', component: LoginFailed },
  {
    path: '',
    component: BaseLayout,
    canActivate: [MsalGuard],
    children: [
      { path: 'products', loadComponent: () => import('./v2/app/pages/product-page/product-page').then((m) => m.ProductPage) },
      {
        // Écran purement transactionnel : le panier n'existe que pour créer une demande d'achat.
        path: 'cart',
        loadComponent: () => import('./v2/app/pages/cart-page/cart-page').then((m) => m.CartPage),
        canActivate: [requisitionDraftGuard],
      },
      { path: 'requisitions', loadComponent: () => import('./v2/app/pages/requisition-page/requisition-page').then((m) => m.RequisitionPage) },
      { path: 'orders', loadComponent: () => import('./v2/app/pages/purchase-order-page/purchase-order-page').then((m) => m.PurchaseOrderPage) },
      { path: 'receipts', loadComponent: () => import('./v2/app/pages/purchase-receipt-page/purchase-receipt-page').then((m) => m.PurchaseReceiptPage) },
      { path: 'returns', loadComponent: () => import('./v2/app/pages/purchase-return-page/purchase-return-page').then((m) => m.PurchaseReturnPage) },
      { path: 'stock-levels', loadComponent: () => import('./v2/app/pages/stock-level-page/stock-level-page').then((m) => m.StockLevelPage) },
      { path: 'inventories', loadComponent: () => import('./v2/app/pages/inventory-page/inventory-page').then((m) => m.InventoryPage),
        canActivate: [inventoryGuard], canDeactivate: [(component: { canLeave(): Promise<boolean> }) => component.canLeave()] },
      { path: 'min-max', loadComponent: () => import('./v2/app/pages/min-max-page/min-max-page').then((m) => m.MinMaxPage) },
      { path: 'auto-replenishment', loadComponent: () => import('./v2/app/pages/auto-replenishment-page/auto-replenishment-page').then((m) => m.AutoReplenishmentPage) },
      { path: 'stock-reservations', loadComponent: () => import('./v2/app/pages/stock-reservation-page/stock-reservation-page').then((m) => m.StockReservationPage) },
      { path: 'stock-movements', loadComponent: () => import('./v2/app/pages/stock-movement-page/stock-movement-page').then((m) => m.StockMovementPage) },
      {
        // Écran purement transactionnel : la sortie en masse n'a aucun mode consultation.
        path: 'bulk-stock-out',
        loadComponent: () => import('./v2/app/pages/bulk-stock-out-page/bulk-stock-out-page').then((m) => m.BulkStockOutPage),
        canActivate: [writeGuard],
      },
      { path: 'traceabilities', loadComponent: () => import('./v2/app/pages/traceability-page/traceability-page').then((m) => m.TraceabilityPage) },
      { path: 'devices', loadComponent: () => import('./v2/app/pages/device-page/device-page').then((m) => m.DevicePage) },
      {
        path: 'non-conformities',
        loadComponent: () => import('./v2/app/pages/non-conformity-page/non-conformity-page').then((m) => m.NonConformityPage),
        canActivate: [nonConformityGuard],
      },
      {
        path: 'admin/sync',
        loadComponent: () => import('./v2/app/pages/admin-sync-page/admin-sync-page').then((m) => m.AdminSyncPage),
        canActivate: [adminGuard],
      },
      {
        // Écran unifié liste-détail : l'historique vit désormais dans admin/sync (volet droit).
        path: 'admin/sync-commands',
        redirectTo: 'admin/sync',
        pathMatch: 'full',
      },
      {
        path: 'admin/rejection-codes',
        loadComponent: () => import('./v2/app/pages/rejection-codes-page/rejection-codes-page').then((m) => m.RejectionCodesPage),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/users',
        loadComponent: () => import('./v2/app/pages/admin-users-page/admin-users-page').then((m) => m.AdminUsersPage),
        canActivate: [adminGuard],
      },
      { path: '**', redirectTo: 'requisitions' },
    ],
  },
]
